<template>
  <div @click="hide_right_menu">
    <el-row :style="sys_code_style" @click="alert(1)">
      <div style="width:100%;height: 100%;position: absolute;z-index: 1000;" class="mask-class" v-if="readonly">

      </div>

      <el-button
        v-drag="{setXY:setXY,getFlag:getFlag,setFlag:setFlag,setForbidClick:setForbidClick}"
        v-bind:icon="left_right_icon" class="btn-toggle "
        @click="open_close_right"
        v-if="has_toggle_btn"

      >

      </el-button>


      <el-row style="display: flex;">


        <el-aside :style="style" class="left_aside"
                  :class="{height_change:!this.server_info_open, 'tree-box': show_input}">
          <el-row style="margin-top: 6px;" v-show="show_input">
            <el-col :span="21 - (has_supper_search ? 3 : 0) - (show_collect ? 3: 0)">
              <el-input
                placeholder="按照节点、IP搜索"
                size="mini"
                v-show="tree_width>100"

                :readonly="readonly"

                @keyup.enter.native="search_data()"
                v-model="search__tree_data.fuzzy_byte">
              </el-input>
            </el-col>
            <el-col :span="3 + (has_supper_search ? 3 : 0) + (show_collect ? 3: 0)">
              <el-button-group style="display: flex;">

                <el-button type="text" @click="search_data" style="padding: 0px 5px !important">
                  <i class="el-icon-refresh-right" style="font-size: 19px;transform: translateY(3px)"></i>
                </el-button>

                <el-button type="text" title="超级查询" style="padding: 0px 5px !important"
                           @click="superSearch" v-if="has_supper_search">
                  <img :src="img_path" style="transform: translateY(2px)"></img>
                </el-button>

                <el-button
                  type="text"
                  title="显示全部"
                  style="padding: 0px 5px !important"
                  v-if="show_collect && !collect_show"
                  @click="show_selected"
                >
                  <img :src="collect_show_path" style="transform: translateY(4px);width: 16px"></img>

                </el-button>

                <el-button
                  type="text"
                  title="显示收藏"
                  v-if="show_collect && collect_show"
                  @click="show_all"
                  style="padding: 0px 5px !important"
                >
                  <img :src="collect_selected" style="transform: translateY(4px);width: 16px"></img>

                </el-button>

                <!--
                            <el-button type="text" title="显示收藏"
                                        icon="el-icon-star-off"
                                        style="padding: 0px 5px !important"
                                                  >

                            </el-button> -->

              </el-button-group>

              <!--<omnis_button href="#the_third_iconfanhui" style="width: 28px; float: right;display: inline-block;cursor: pointer;top: 2px;" @handle_click="handle_close_tree"></omnis_button>-->

            </el-col>
          </el-row>
          <hr style=" border: none;height: 1px;background-color: #d5d5d5;" v-show="show_input">

          <el-row :style="tree_style" class="tree_row">
            <el-tree
              v-if="tree_type == '0'&& tree_show"
              icon-class="el-icon-omnis-zuzhi"
              :style="sys_code_style.backgroundColor ? {backgroundColor: sys_code_style.backgroundColor} : {}"
              class="data_tree tree_body scrollbar-mini"
              :data="data"
              :props="defaultProps"
              size="mini"
              :node-key="value_field"
              :filter-node-method="filterNode"
              v-loading="loading"
              highlight-current

              :default-expanded-keys="tree_default_expanded_keys"
              @node-click="handleNodeClick"
              @node-expand="tree_node_expand"
              @node-collapse="tree_node_collapse"
              :render-after-expand="false"

              ref="tree">
          <span class="custom-tree-node" style="overflow: hidden" slot-scope="{ node, data }">

            <svg
              title="这是个生产环境"
              v-if="data.id_type=='server_env_id' && data.env_code=='3'"
              class=" env_icon" aria-hidden="true" style="">
                    <use class="" xlink:href="#the_third_iconhuanjing-copy"></use>
             </svg>
            <svg
              title="这是个开发环境"
              v-else-if="data.id_type=='server_env_id' && data.env_code=='4'"
              class=" env_icon" aria-hidden="true">
                    <use class="" xlink:href="#the_third_iconhuanjing-copy-copy"></use>
             </svg>

             <svg
               title="这是个测试环境"
               v-else-if="data.id_type=='server_env_id' "
               class=" env_icon" aria-hidden="true">
                    <use class="" xlink:href="#the_third_iconhuanjing_png"></use>
             </svg>
            <span>{{ node.label }}</span>
          </span>
            </el-tree>


            <el-row class="tree_body" v-loading="loading" style="display: flex;">


              <tree v-if="tree_type == '1'"
                    ref="ztree_ref"
                    @onDblClick="ztree_on_dbl_click"
                    @onRightClick="OnRightClick"
                    :nodes="show_ztree_data"
                    :setting="setting">


              </tree>


            </el-row>

            <!--        :render-content="renderContent"-->
          </el-row>
          <el-dialog
            title="超级搜索"
            class="search_body"
            :visible.sync="dialogVisible"
            width="95%"
            :close-on-click-modal="false"
            append-to-body
            top="5vh"
          >
            <el-row class="el-table-filter" style="padding-top: 10px">
              <el-form ref="super_search_form" :model="super_search_data" label-width="90px" size="mini">
                <el-form-item label="区域范围" prop="">

                  <search_tree_select ref="search_tree_select" @change="area_change"
                                      multiple
                                      size="mini"
                  >
                  </search_tree_select>


                </el-form-item>

                <el-form-item label="关键字范围">
                  <el-col :span="7" class="el-form-item-padding" prop="area_keyword_ranges">
                    <sys_code_select
                      sys_code_type="area_keyword_range"
                      sys_code_multiple
                      v-model="super_search_data.area_keyword_ranges"

                    >
                    </sys_code_select>
                  </el-col>
                  <el-col :span="1">
                    关键字
                  </el-col>
                  <el-col :span="16">

                    <el-input placeholder="请输入多个关键字，以逗号分割" size="mini" v-model="super_search_data.keyword"></el-input>

                  </el-col>

                </el-form-item>
                <el-form-item label="内存">

                  <el-col :span="2">
                    <el-select v-model="super_search_data.memory_size_sign" size="mini" class="data_type">
                      <el-option label="=" value="="></el-option>
                      <el-option label=">" value=">"></el-option>
                      <el-option label="<" value="<"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5" class="el-form-item-padding">
                    <el-input placeholder="请输入数值,单位GB" size="mini" v-model="super_search_data.memory_size"></el-input>

                  </el-col>


                  <el-col :span="1">
                    磁盘
                  </el-col>
                  <el-col :span="2">
                    <el-select v-model="super_search_data.disk_total_size_sign" size="mini" class="data_type">
                      <el-option label="=" value="="></el-option>
                      <el-option label=">" value=">"></el-option>
                      <el-option label="<" value="<"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5" class="el-form-item-padding">
                    <el-input placeholder="请输入数值,单位GB" size="mini"
                              v-model="super_search_data.disk_total_size"></el-input>
                  </el-col>


                  <el-col :span="2">
                    CPU核心
                  </el-col>

                  <el-col :span="2">
                    <el-select v-model="super_search_data.cpu_cores_sign" size="mini" class="data_type">
                      <el-option label="=" value="="></el-option>
                      <el-option label=">" value=">"></el-option>
                      <el-option label="<" value="<"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <el-input placeholder="请输入数值,单位个" size="mini" v-model="super_search_data.cpu_cores"></el-input>

                  </el-col>

                </el-form-item>
                <el-form-item label="系统">
                  <el-col :span="7" class="el-form-item-padding">
                    <sys_code_select
                      :sys_code_has_all="false"
                      sys_code_type="server_os_type"
                      v-model="super_search_data.fuzzy_server_os_type"

                    >
                    </sys_code_select>
                  </el-col>
                  <el-col :span="1">
                    主服务
                  </el-col>

                  <el-col :span="7" class="el-form-item-padding">
                    <sys_code_select
                      :sys_code_has_all="false"
                      sys_code_type="server_service_type"
                      v-model="super_search_data.server_service_type"
                    >
                    </sys_code_select>
                  </el-col>
                  <el-col :span="2">
                    主机类型
                  </el-col>
                  <el-col :span="4">

                    <sys_code_select
                      :sys_code_has_all="false"
                      sys_code_type="server_virtualization_type"
                      v-model="super_search_data.server_virtualization_type"
                    >
                    </sys_code_select>

                  </el-col>
                  <el-col :span="2" style="padding-left: 5px">
                    <el-button type="primary" size="mini" icon="el-icon-search" @click="super_search">搜索</el-button>
                    <el-button type="primary" size="mini" icon="el-icon-refresh-left" @click="reset_super_search">重置
                    </el-button>
                  </el-col>
                </el-form-item>
              </el-form>
            </el-row>
            <el-row>
              <el-table
                v-loading="super_loading"
                size="mini"
                :data="tableData"
                stripe

                height="450"
                style="width: 100%">
                <el-table-column
                  type="index"
                >

                </el-table-column>
                <el-table-column
                  prop="assets_path"
                  label="区域"
                  show-overflow-tooltip
                  width="320">
                </el-table-column>
                <el-table-column
                  prop="server_ip"
                  label="IP"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="server_name"
                  label="主机名"
                  width="180"
                >
                </el-table-column>

                <el-table-column
                  prop="fuzzy_server_os_type_name"
                  label="系统">
                </el-table-column>
                <el-table-column
                  prop="server_service_type_text"
                  label="主服务">
                </el-table-column>
                <el-table-column
                  prop="server_virtualization_type_name"

                  width="90"
                  label="主机类型">
                </el-table-column>
                <el-table-column
                  prop="monitor_agent_id"
                  show-overflow-tooltip
                  label="探针名称">
                </el-table-column>
                <el-table-column
                  prop="memory_size"
                  width="90"
                  label="内存">
                </el-table-column>
                <el-table-column
                  prop="disk_total_size"
                  width="90"
                  label="磁盘">
                </el-table-column>
                <el-table-column
                  prop="cpu_cores"
                  width="90"
                  label="CPU">
                </el-table-column>
              </el-table>
            </el-row>
            <el-row>
              <el-pagination
                size="mini"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="super_search_data.page"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="super_search_data.size"

                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </el-row>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" size="mini" @click="dialogVisible = false">关闭</el-button>
              <el-button type="primary" size="mini" @click="dialogVisible = false">确 定</el-button>
            </span>
          </el-dialog>

        </el-aside>

        <div id="resize" :style="{height:style.height}" v-if="can_left_drag">

          <div>.</div>
        </div>


      </el-row>

      <el-row :style="server_info_style " v-show="show_information" v-if="show_computer" class="height_change">

        <el-row class="panel-header notice_header">
          <el-col class="panel-title">
            <div style="float: left">主机信息 资源名称:XXXX</div>
            <div style="float:right">
              <el-button type="text" class="el-icon-omnis-jiantou2 rotate-change" style="color:#409EFF;font-size: 10px"
                         title="隐藏" @click="logServerInfo" :class="{'rotate':rotate}"></el-button>
            </div>
          </el-col>
        </el-row>
        <!--      <transition name="el-fade-in-linear">-->
        <el-row class="server-info" v-show="server_info_open">
          <table>
            <tr>
              <td>
                主机名:
              </td>
              <td>
                k8s-node1
              </td>
            </tr>

            <tr>
              <td>
                主机IP:
              </td>
              <td>
                192.168.20.163
              </td>
            </tr>

            <tr>
              <td>
                端口:
              </td>
              <td>
                22
              </td>
            </tr>
            <tr>
              <td>
                主要服务:
              </td>
              <td>
                中间件服务
              </td>
            </tr>

            <tr>
              <td>
                CPU:
              </td>
              <td>
                20%
              </td>
            </tr>


            <tr>
              <td>
                内存:
              </td>
              <td>
                40%
              </td>
            </tr>
            <tr>
              <td>
                磁盘可用:
              </td>
              <td>
                20G
              </td>
            </tr>

            <tr>
              <td>
                运行:
              </td>
              <td>
                108天
              </td>
            </tr>
          </table>
        </el-row>
        <!--       </transition>-->


      </el-row>
    </el-row>


    <ul id="database_right_menu" class="directory-tree-menu" v-if="show_right_menu" :style="right_menu_style">


      <li @click="watch_webshell"
          v-if="!current_right_node.is_watch"
          v-loading="watch_webshell_loading">

        <svg class="icon" aria-hidden="true"

        >
          <use xlink:href="#the_third_iconshoucang1"></use>

        </svg>
        收藏
      </li>

      <li @click="unwatch_webshell"
          v-if="current_right_node.is_watch"
          v-loading="watch_webshell_loading">

        <svg class="icon" aria-hidden="true"

        >
          <use xlink:href="#the_third_iconshanchuhang"></use>

        </svg>
        删除收藏
      </li>

      <li @click="show_history">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#the_third_iconshell-glyph-color"></use>
        </svg>
        操作记录
      </li>

      <li @click="show_right_menu=false">

        <svg class="icon" aria-hidden="true"

        >
          <use xlink:href="#the_third_iconquxiao3"></use>

        </svg>
        取消
      </li>

    </ul>
  </div>


</template>

<script>
  import * as API from "@/api/index.js"
  import search_tree_select from "@/components/common_page/search_tree_select"
  import sys_code_select from "@/components/common_page/sys_code_select"
  import * as common from "@/common/index.js"
  import {EventBus} from "@/components/assets_operations/env_init/all_steps/event_bus/event-bus.js";
  import tree from "vue-giant-tree"
  import omnis_button from "@/components/common_page/omnis_button"
  import ztree_opt from "@/components/common_page/mixin/ztree_opt_func.js"

  export default {

    mixins: [ztree_opt],
    model:{
        prop:"target_value",
        event:"change",
    },
    props: {
      target_value: {

      },
      k8type: {
        type: String,
        default: "",
      },
      value_field:{
        type: String,
        default: "id"
      },
      env_type:{
        type: String,
        default: "",
      },
      value_type:{
        type: String,
        default: "",   //  tree_type 为 0，且使用v-model数据双向绑定，则必传
      },

      search_select_auto:{
        type: Boolean,
        default: true
      },

      //是否支持左右拖动，父组件必须实现对resize 进行监听，以及计算宽度，值赋给 tree_width
      can_left_drag: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      default_env: {
        type: String,
        default: ""
      },
      sys_code_style: {//选择器样式
        type: Object,
        default: function () {
          return {
            "width": "100%",
          }
        }
      },
      show_information: {
        type: Boolean,
        default: true
      },
      show_computer: {
        type: Boolean,
        default: false
      },
      has_supper_search: {
        type: Boolean,
        default: false
      },
      content_height: {
        type: String,
        default: "-1"
      },

      show_input: {
        type: Boolean,
        default: true    //  false时 隐藏上方input框
      },

      search_text: {
        type: String,
        default: ""
      },

      tree_type: {
        type: String,
        default: "0",   // 0: el-tree  1: ztree
      },

      tree_width: {//左侧区域的宽度
        type: Number,
        default: 300,
      },
      show_collect: {
        type: Boolean,
        default: false
      },

      has_toggle_btn: {   // 是否需要右侧用以收缩的按钮
        type: Boolean,
        default: true,
      }
    },
    components: {
      search_tree_select,
      sys_code_select,
      tree,
      omnis_button,
    },
    data() {
      return {
        current_value_type: "",
        current_value: null,
        current_data: {},

        has_watch: false,

        right_menu_style: {
          'top': '0px',
          'left': '0px',

        },

        show_right_menu: false,
        current_right_node: null,
        collect_show: true,//显示是否收藏，默认显示收藏
        isShowAside: true,
        forbid_click: false,
        x: "0",
        y: "0",
        flag: false,

        super_loading: false,
        rotate: false,
        tree_show: true,
        total: 0,
        loading: false,
        search__tree_data: {
          fuzzy_byte: "",
          id_type: "",
        },
        super_search_data: {
          page: 1,
          size: 10,
          server_env_id: "",
          keyword: "",
          area_keyword_ranges: "",
          memory_size_sign: "",
          memory_size: "",
          disk_total_size: "",
          disk_total_size_sign: "",
          cpu_cores: "",
          cpu_cores_sign: "",
          fuzzy_server_os_type: "",
          server_service_type_code: "",
          server_virtualization_type: ""

        },

        currentPage: 1,
        form: {},
        tree_default_expanded_keys: [],
        loading: false,
        filterText: "",
        dialogVisible: false,
        img_path: require("@/assets/super_search.png"),
        collect_show_path: require("@/assets/collect_show.png"),
        collect_selected: require("@/assets/collect_selected.png"),
        filterText: '',
        data: [],
        tree_height: 200,
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        style: {
          width: "100%",
          height: '300px',

        },
        tree_style: {
          height: '300px',
        },
        server_info_style: {
          'height': '290px',
          'margin-top': '5px'
        },
        tableData: [],
        current_item: {},
        server_info_height: 290,
        table_style: {height: "250px"},
        server_info_open: true,
        table_style: {
          height: "0px"
        },
        last_project: "",
        last_area: "",
        project_conf: {
          project_id: "",
          project_code: "",
          project_name: "",
        },
        tree_dict_data: {},
        focus_input: false,
        ztree_data: [],    // ztree数据

        setting: {
          data: {
            key: {
              title: "title"
            },
            simpleData: {
              enable: true,
              idKey: "id",
              pIdKey: "pid",
              // rootPId: null
            },
          },
          view: {
            showIcon: true,
            nameIsHTML: true,
            fontCss: {"font-size": "12px", "font-family": "微软雅黑bai"}
          }
        },  // ztree 配置
        server_checked_icon: "icon-server-selected",  // ztree 主机选中图标
        server_unchecked_icon: "icon-server",  // ztree 主机选中图标
        server_unchecked_icon_collect: "icon-server-collect",  // ztree 关注主机选中图标
        server_checked_icon_collect: "icon-server-collect-selected",  // ztree 关注主机未选中图标

        ztree_data_dict: {},  // ztree数据 的字典形式，{id: {}, ...}
        formal_env_icon: "icon-red-leaf",  // ztree 生产环境图标
        dev_env_icon: "icon-blue-leaf",  // ztree 开发环境图标
        other_env_icon: "icon-green-leaf",  // ztree 其他环境图标
        ztree_search_text: "",  // 搜索数据
        ztree_checked_id: [],   // 选中数据的id数组
        watch_webshell_form: {},
        watch_webshell_loading: false,

      };
    },
    watch: {

      content_height(val){
        this.$nextTick(() => {
          this.tree_height_set();
        })
      },

      current_data: {
        handler(data){
          this.$emit("data_change", data)
        },
        deep: true,
        immediate: true,
      },

      current_value(val){
        this.target_value
        this.$emit("change", val);
        this.set_current_node(val);
      },

      target_value: {
        handler(data){
          this.current_value = data;
        },
        deep: true,
        immediate: true,
      },
      // target_value(val){
      //   debugger
      //   this.current_value = val;
      // },

      collect_show(value) {
        if (value) {
          let nodes = this.$refs.ztree_ref.ztreeObj.getNodes()
          //处理关注的显示
          nodes.map(parent => {
            if (parent.children) {
              let children = parent.children
              children.map(server_node => {
                let id = server_node.id

                let base = this.get_node_data_by_id_from_base(id)
                if (base.is_watch != server_node.is_watch) {
                  base.is_watch = server_node.is_watch
                  this.fix_icon(base)
                }
              })
            }
          })
        }
      },


      tree_width(data) {
        this.style = {width: data + "px", height: this.style.height + "px"}
      },


      search_text(val){
          this.search__tree_data.fuzzy_byte = val
          this.getData()
      },

      default_env(val) {
        // this.set_default_node()
        this.set_current_value()

      },
      server_info_open(value) {

        if (value) {
          this.server_info_style.height = this.server_info_height + "px"
        } else {
          this.server_info_style.height = "30px"
        }

        let treeHeight = this.changeTreeHeight(value)
        this.style.height = treeHeight + "px"
        this.tree_style.height = (treeHeight - 50) + 'px'
      },
      'search__tree_data.fuzzy_byte': {
        handler(data) {
          EventBus.$emit("tree_fuzzy_byte", data);
        },
        deep: true
      }
    },
    computed: {

      // ztree数据
      show_ztree_data() {
        if (this.tree_type == '1') {
          let search_text = this.ztree_search_text.trim()
          let result = this.ztree_data
          if (search_text) {//如果有过滤条件
            result = this.handler_search_text_node(search_text)
          } else {
            // result.map(item=>{
            //   item.open = false
            // })
          }

          setTimeout(() => {
            this.set_checked_node()  // 更新所有选中节点的样式
          }, 100)


          if (this.has_watch_node(result) && this.collect_show) {//如果存在，已经关注的节点
            result = this.handler_show_watch_node(result)

          } else {//如果没有任何关注项，将关注设置全部
            this.collect_show = false
          }


          return result
        }
      },


      left_right_icon() {
        if (this.isShowAside) {
          return 'el-icon-d-arrow-left'
        } else {
          return 'el-icon-d-arrow-right'

        }

      }

    },
    mounted() {

      this.set_current_value()
      this.current_value_type = this.value_type;
      if (this.tree_type == '0') {
        this.getData()
      } else {
        this.get_ztree_data()
      }
      this.$nextTick(() => {
        this.tree_height_set();
      })

    },

    methods: {

      current_node_cancel(){
        if (this.tree_type === '0') {
          if (this.$refs.tree) this.$refs.tree.setCurrentKey(null);
        } else {
          let tree_obj = this.get_tree_obj("ztree_ref");
          if (tree_obj){
            tree_obj.cancelSelectedNode();
          }
        }
      },

      tree_height_set(){
          if (this.content_height == "-1") {
            // this.style.height = this.getTreeHeight() + "px"
            this.style.height = common.getTableHeight(-100) + "px"
            this.tree_style.height = common.getTableHeight(-155) + 'px'
          } else if (this.content_height == "-3") {

            if (this.show_input) {
              this.style.height = '460px'
              this.tree_style.height = '410px'
            } else {
              this.style.height = '310px'
              this.tree_style.height = '300px'
            }


          } else {
            let height = 0;
            if (this.content_height.indexOf("px")) {
              height = parseInt(this.content_height.replace("px", ""))
            }
            this.style.height = height + "px"
            this.tree_style.height = (height - 50) + "px"
          }
      },

      set_current_value(){
        this.current_value = this.target_value;
        if (!this.current_value && this.default_env){
          this.current_value = this.default_env;
        }
      },

      set_current_node(val){
        this.$nextTick(() =>{
          if (val && (!this.current_data || this.current_data[this.value_field] !== val || this.current_data.source_type === 'search')){
            let node = this.get_current_data(this.value_field, val);
            if (node){
                if (this.tree_type == '0'){
                  this.current_data = node.data
                  if (this.last_area) {
                    this.last_area.expanded = false
                  }
                  if (this.last_project) {
                    this.last_project.expanded = false
                  }
                  let area = node.parent
                  let project = area.parent
                  project.expanded = true
                  area.expanded = true
                  this.last_project = project
                  this.last_area = area
                  if (this.$refs.tree){
                    try {
                      this.$refs.tree.setCurrentKey(val);
                      setTimeout(() =>{
                        this.set_scroll_top(node);
                      }, 500)

                    }catch (e) {
                      console.log(e);
                    }

                  }

                }else if (this.tree_type == '1'){
                  this.current_data = node
                  let tree_obj = this.get_tree_obj("ztree_ref");
                  if (tree_obj){
                    tree_obj.selectNode(this.current_data);
                  }

                }

            }else if (!node && this.tree_type == '0' && this.current_value_type === 'server'){
              this.get_server_ip(val, (data) =>{
                this.current_data = data;
                this.current_data.source_type = 'search'
              })
            }

          }

        })

      },

      // 设置滚动条位置
      set_scroll_top(node){
        this.$nextTick(() => {
          let arr = this.get_scroll_top_node_num(node);
          let h = this.$el.querySelector(".tree_body").offsetHeight / 3;
          let node_h = this.$el.querySelector(".tree_body .el-tree-node__content").offsetHeight;
          this.$el.querySelector(".tree_body").scrollTop = ( arr.reduce((t, i) => t + i) - 1 ) * node_h - h; // 减1：去掉当前节点占位
        })
      },

      // 获取设置滚动条位置需计算的节点数
      get_scroll_top_node_num(node){
        let index_data = []
        while (node.level > 0){
          let node_data= node.data;
          let node_parent = node.parent;
          let node_sibling = node.level > 1 ? node_parent.data[this.defaultProps.children] : node_parent.data;
          let index = node_sibling.findIndex(n => n[this.value_field] === node_data[this.value_field]) + 1;
          index_data.push(index);
          node = node_parent;
        }
        return index_data;
      },

      get_current_data(key, val){
        if (this.tree_type == '0' && this.$refs.tree){
          // for(var i=0; i<data.length; i++){
          //   let node = data[i];
          //   if (node[this.value_field] === val){
          //     return node;
          //   }
          //   if (node.children && node.children.length > 0){
          //     let child = this.get_current_data(node.children, key, val)
          //     if (child) return child
          //   }
          // }
          let node = this.$refs.tree.getNode(val);
          return node;
        }
        else if (this.tree_type == '1'){
          let tree_obj = this.get_tree_obj("ztree_ref");
          if (tree_obj){
            let node = tree_obj.getNodeByParam(key, val);
            return node;
          }
        }
        return null;

      },

      show_history() {
        this.show_right_menu = false
        this.$emit("show_history", this.current_right_node.server_id, this.current_right_node)
      },
      has_child(pid, nodes) {
        for (let i = 0; i < nodes.length; i++) {
          let node = nodes[i]
          if (node.pid && node.pid == pid) {
            return true
          }
        }

      },
      get_children(pid, nodes) {
        let children = []
        for (let i = 0; i < nodes.length; i++) {
          let node = nodes[i]
          if (node.pid && node.pid == pid) {
            children.push(node)
          }

        }
        return children
      },
      //是否与关注项
      has_watch_node(nodes) {

        for (let i = 0; i < nodes.length; i++) {
          let server = nodes[i]
          if (server.is_watch) {
            return true
          }
        }
        return false
      },
      handler_show_watch_node(nodes) {

        //关注节点
        let watch_node = []
        let pid = []
        for (let i = 0; i < nodes.length; i++) {
          let node = nodes[i]
          if (node.is_watch) {
            watch_node.push(node)
            if (pid.indexOf(node.pid) < 0) {
              pid.push(node.pid)
            }
          }
        }
        nodes.map(node => {//添加父节点
          if (pid.indexOf(node.id) >= 0) {
            if (pid.length <= 10) {
              node.open = true
            }
            watch_node.push(node)
          }
        })
        return watch_node


      },

      handler_search_text_node(search_text) {

        let tree_data = []//节点对象
        let child_pid = []//父节点ID
        let match_data_id = []//当前节点ID
        let pid_node = []
        this.ztree_data.map((node) => {//直接显示匹配，环境名称、主机IP,如果匹配上了，就添加节点
          if (node.name.indexOf(search_text) > -1) {
            tree_data.push(node)
            match_data_id.push(node.id)
            if (node.pid) {
              child_pid.push(node.pid)
            }
          }
        })

        this.ztree_data.map((node) => {//处理父节点，如果子节点匹配，但是没有父节点，添加父节点
          if (child_pid.indexOf(node.id) > -1 && match_data_id.indexOf(node.id) == -1) {
            let temp = Object.assign({}, node)
            temp.open = true
            pid_node.push(temp)
          }
        })


        tree_data = pid_node.concat(tree_data)
        let children = []
        tree_data.map(node => {
          if (!node.pid) {//如果是父节点
            if (!this.has_child(node.id, tree_data)) {//如果没有子节点
              let c = this.get_children(node.id, this.ztree_data)
              children = children.concat(c)//添加该节点全部子节点
            }
          }
        })

        tree_data = tree_data.concat(children)
        return tree_data

      },
      watch_webshell() {
        this.watch_webshell_form.server_id = this.current_right_node.server_id
        this.watch_webshell_data()
      },
      async watch_webshell_data() {
        this.watch_webshell_loading = true
        let response = await API.POST("/omnis/fort_service/webshell_watch", this.watch_webshell_form)
        this.watch_webshell_loading = false
        let data = response.data
        if (data.success) {
          this.show_msg("关注成功！")
          this.show_right_menu = false

          let node = this.get_node_data_by_id(this.current_right_node.id)
          if (node) {
            this.current_right_node.is_watch = true
            node.is_watch = true


            this.fix_icon(node)
            this.$refs.ztree_ref.ztreeObj.updateNode(node)
          }


        } else {
          this.show_msg(data.msg, "error")
        }
      },

      unwatch_webshell() {
        this.watch_webshell_form.server_id = this.current_right_node.server_id
        this.unwatch_webshell_data()
      },
      async unwatch_webshell_data() {
        this.watch_webshell_loading = true
        let response = await API.DELETE("/omnis/fort_service/webshell_watch", this.watch_webshell_form)
        this.watch_webshell_loading = false
        let data = response.data
        if (data.success) {
          this.show_msg("取消关注成功！")
          this.show_right_menu = false

          let node = this.get_node_data_by_id_from_base(this.current_right_node.id)
          if (node) {
            this.current_right_node.is_watch = false
            node.is_watch = false
            this.fix_icon(node)
            // this.$refs.ztree_ref.ztreeObj.updateNode(node)
          }


        } else {
          this.show_msg(data.msg, "error")
        }
      },

      get_node_data_by_id(id) {
        let treeObj = this.$refs.ztree_ref.ztreeObj
        let node = treeObj.getNodeByParam("id", id)
        return node

      },
      get_node_data_by_id_from_base(id) {
        if (this.ztree_data_dict[id]) {
          return this.ztree_data_dict[id]
        } else {
          return null
        }
      },


      hide_right_menu(event) {


        let database_right_menu = document.getElementById("database_right_menu")
        if (database_right_menu && !database_right_menu.contains(event.target)) {//隐藏数据库的右键显示

          this.show_right_menu = false
        }


      },

      showRMenu(treeNode, x, y, event) {


        //
        this.show_right_menu = true

        if (y + 100 > window.innerHeight) y -= 65;
        this.right_menu_style.top = (y - 70) + "px"
        if (x > 200) {
          x -= 80
        }
        this.right_menu_style.left = x + "px"

        // if(event.offsetX>100){
        //   this.right_menu_style.left =(event.offsetX)+"px"
        // }

        // this.right_menu_style.left -= (x-event.offsetX)

        this.current_right_node = treeNode

      },

      OnRightClick(event, treeId, treeNode) {
        if (!treeNode) {
          return
        }
        //如果是父节点，就不能右键
        if (treeNode.isParent) {
          return
        }
        this.$refs.ztree_ref.ztreeObj.selectNode(treeNode)
        this.showRMenu(treeNode, event.clientX, event.clientY, event)
      },

      show_all() {
        this.collect_show = false

      },
      show_selected() {
        this.collect_show = true
      },

      handle_close_tree() {
        this.$emit("handle_close_tree", false, 20)
      },

      // 更新所有选中节点的样式
      set_checked_node() {
        this.ztree_checked_id.map((id) => {
          this.set_node_checked(id, true)
        })
      },


      // 节点选中 或者 取消选中后 ，更新节点的样式
      set_node_checked(server_id, checked) {
        let icon
        let is_watch = false
        let treeObj = this.$refs.ztree_ref.ztreeObj
        let node = treeObj.getNodeByParam("id", server_id)
        if (node) {
          is_watch = node.is_watch
        }
        if (is_watch) {//如果关注显示图标


          if (checked) {
            icon = this.server_checked_icon_collect
          } else {
            icon = this.server_unchecked_icon_collect
          }

          // icon = this.server_unchecked_icon_collect

        } else {//非关注显示图标
          if (checked === true) {
            icon = this.server_checked_icon
          } else {
            icon = this.server_unchecked_icon
          }
        }


        if (node && node.iconSkin != icon) {
          node.iconSkin = icon
          node.name = checked ? `<span style="font-weight:bold;font-size:12px;color:#1296db">${node.original}</span>` : node.original
          node.title = checked ? "已连接" + node.original : node.original
          this.$refs.ztree_ref.ztreeObj.updateNode(node)   // 更新子节点

          let parent_node = treeObj.getNodeByParam("id", node.pid)
          if (parent_node && !parent_node.open) {
            this.$refs.ztree_ref.ztreeObj.expandNode(parent_node, true, false, true)   // 展开父节点  true, false, true =》 展开， 只影响此节点，对于其 子孙节点无任何影响， 展开 / 折叠 操作后，通过设置焦点保证此焦点进入可视区域内
          }

          let exist = this.ztree_checked_id.indexOf(server_id) > -1 ? true : false
          if (checked && !exist) {
            this.ztree_checked_id.push(server_id)
          }
          if (!checked && exist) {
            this.ztree_checked_id = this.ztree_checked_id.filter(id => id != server_id)
          }
        }

      },


      // 双击节点
      ztree_on_dbl_click(event, treeId, treeNode) {
        if (treeNode.pid) {    // 子层级
          this.current_value = treeNode[this.value_field]
          this.current_data = treeNode;
          this.$emit("item_click", treeNode, this.search__tree_data.fuzzy_byte)
        }
      },

      input_blur() {
        this.focus_input = false
      },

      input_focus() {
        this.focus_input = true
      },

      get_tree_dict(data, data_dict, project_conf) {
        data.forEach(row => {

          if (row.id_type == "sys_project_id") {
            if (row.children && row.children.length > 0) {
              let temp_project = {"project_id": row.id, "project_code": row.code, "project_name": row.name}
              this.get_tree_dict(row.children, data_dict, temp_project)
            }
          } else {
            data_dict[row.id] = project_conf
            if (row.children && row.children.length > 0) {
              this.get_tree_dict(row.children, data_dict, project_conf)
            }
          }

        })
      },


      open_close_right() {
        if (this.getForbidClick()) {
          this.setForbidClick(false)
          return
        }
        // console.log("click")
        this.isShowAside = !this.isShowAside
        this.$emit("show_aside", this.isShowAside)

      },

      setXY: function (x, y) {
        this.x = x;
        this.y = y;
      },
      setForbidClick(forbid_click) {
        this.forbid_click = forbid_click
      },
      getForbidClick() {
        return this.forbid_click
      },
      getFlag: function () {
        return this.flag;
      },
      setFlag: function (num) {
        this.flag = num;
      },

      logServerInfo() {
        this.server_info_open = !this.server_info_open
        this.rotate = !this.rotate
      },

      // renderContent(h, { node, data, store }) {
      //
      //       if (data.id_type &&　data.id_type == 'server_env_id'){
      //         if(this.show_computer){//如果显示电脑
      //            if (!data.children) {
      //             this.$set(data, 'children', []);
      //           }
      //           node.isLeaf = false
      //         }
      //         return (
      //           <span class="custom-tree-node">
      //             <span >{node.label}</span>
      //           </span>
      //       );
      //       }else if(data.id_type &&　data.id_type == 'server'){
      //          return ( <span class="custom-tree-node"><span style="font-size:12px"><i class="el-icon-s-platform"></i>{node.label}</span> </span>);
      //       }else{
      //         return ( <span class="custom-tree-node"> <span　> <i ></i>{node.label}</span> </span>);
      //       }
      //
      //     },
      area_change(data) {//区域改变

        this.super_search_data.server_env_id = data.join(",")
      },
      server_service_type_code_change(data) {//主服务
        this.super_search_data.server_service_type_code = data
      },
      fuzzy_server_os_type_change(data) {//系统改变
        this.super_search_data.fuzzy_server_os_type = data
      },
      area_keyword_range_change(data) {//关键字改变
        this.super_search_data.area_keyword_ranges = data.join(",")
      },
      reset_super_search() {
        this.$nextTick(() => {
          this.$refs.search_tree_select.clearSelectedNodes()
          this.$refs.super_search_form.resetFields()
          this.total = 0
          this.super_search_data = {
            page: 1,
            size: 10,
            server_env_id: "",
            keyword: "",
            area_keyword_ranges: "",
            memory_size_sign: "",
            memory_size: "",
            disk_total_size: "",
            disk_total_size_sign: "",
            cpu_cores: "",
            cpu_cores_sign: "",
            fuzzy_server_os_type: "",
            server_service_type_code: ""
          }
          this.super_search()
        })


      },
      async super_search() {

        this.super_loading = true
        const response = await API.POST("/omnis/assets_operations/sub_organization_info/super_search", this.super_search_data)
        this.super_loading = false
        if (response && response.data) {
          var data = response.data
          this.tableData = data.data
          this.total = data.count
        }

      },
      handleSizeChange(val) {
        this.super_search_data.page = 1
        this.super_search_data.size = val
        this.super_search()

      },
      handleCurrentChange(val) {
        this.super_search_data.page = val
        this.super_search()
      },
      async appendChildren() {
        let datas = {'server_env_id': this.current_item.id}
        this.loading = true
        const response = await API.GET('/omnis/assets_operations/sub_organization_info/sub_or_list', datas)
        this.loading = false
        let data = response.data
        if (data.success) {
          let items = data.data
          for (let i = 0; i < items.length; i++) {
            let item = items [i]
            let item_obj = {id_type: "server", "id": item.server_id}
            if (item.soft_name) {
              item_obj["name"] = item.server_ip + "(" + item.soft_name + ")"
            } else {
              item_obj["name"] = item.server_ip
            }
            // this.current_item.children.push(item_obj)
            this.$refs.tree.append(item_obj, this.current_item)

          }


        }
      },

      handleNodeClick(item, node) {
        if (this.readonly) {
          return true
        }
        if (item.id_type == "sys_project_id") {
          this.project_conf.project_id = item.id
          this.project_conf.project_code = item.code
          this.project_conf.project_name = item.name
        } else {
          if (item.id in this.tree_dict_data) {
            this.project_conf = Object.assign({}, this.tree_dict_data[item.id])
          }
        }
        item.rotate = !item.rotate

        if (item["id_type"] == "server_env_id") {
          if (this.show_computer) {
            this.current_item = item
            if (item.children && item.children.length == 0) {
              this.$nextTick(() => {
                this.appendChildren()
              })

            }
          } else {
            let project_code = ""
            if (node.parent && node.parent.parent && node.parent.parent.data["code"]) {
              project_code = node.parent.parent.data["code"]
            }

            item['project_code'] = project_code
            this.$emit("item_click", item, this.search__tree_data.fuzzy_byte)

          }
        } else if (item["id_type"] == "server") {
          this.$emit("item_click", item, this.search__tree_data.fuzzy_byte)
        }

        if (!this.current_value_type || (this.current_value_type && this.current_value_type === item["id_type"])){
          this.current_value = item[this.value_field];
          this.current_data = item;
        }


      },
      tree_node_expand(data) {
        var key = data["id"]
        var index = this.tree_default_expanded_keys.indexOf(key)
        // console.log(this.tree_default_expanded_keys)
        if (index == -1) {
          this.tree_default_expanded_keys.push(key)
        }

      },

      tree_node_collapse(data) {
        var key = data["id"]
        var index = this.tree_default_expanded_keys.indexOf(key)
        if (index != -1) {
          this.tree_default_expanded_keys.remove(key)
        }
      },
      search_data() {

        if (this.tree_type == '1') {
          this.ztree_search_text = this.search__tree_data.fuzzy_byte
        } else {
          this.getData()
        }

      },
      superSearch() {
        this.dialogVisible = true
        this.reset_super_search()
      },

      getTreeHeight() {
        if (this.show_computer) {
          return window.screen.height - 250 - this.server_info_height
        } else {
          return window.screen.height - 250
        }
      },
      /**
       * 返回树的高度
       * @param val
       * @returns {number}
       */
      changeTreeHeight(val) {

        if (val) {
          return window.screen.height - 250 - this.server_info_height
        } else {
          return window.screen.height - 290
        }
      },
      filterNode(value, data) {

        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      treeNodeALLOpen(open) {
        this.$refs.tree.store.defaultExpandAll = open

        this.tree_show = false
        this.tree_show = true
      },
      set_default_node(val) {
        this.$nextTick(() => {
          if (this.last_area) {
            this.last_area.expanded = false
          }
          if (this.last_project) {
            this.last_project.expanded = false
          }

          let node = this.$refs.tree.getNode(val)
          if (node) {
            let area = node.parent
            let project = area.parent
            project.expanded = true
            area.expanded = true
            this.last_project = project
            this.last_area = area
            this.$refs.tree.setCurrentKey(val)
          }


        })


      },
      async getData() {
        // console.log(this.k8type,'k8type')
        this.loading = true
        this.search__tree_data.fuzzy_byte = this.search__tree_data.fuzzy_byte.trim()
        if (this.show_computer && this.search__tree_data.fuzzy_byte) {
          this.search__tree_data.id_type = "server"
        } else {
          this.search__tree_data.id_type = ""
        }
        if(this.k8type == 'k8type'){
          this.search__tree_data.env_type = '1'
        }
        if(this.k8type == 'deploy'){
          this.search__tree_data.env_type = '0'
        }
        // console.log(this.k8type)
        const response = await API.GET('/omnis/assets_operations/area_organization_info_tree/', this.search__tree_data)
        this.loading = false
        if (response && response.data) {

          var data = response.data

          if (data.success) {

            //展开节点
            if (this.search__tree_data.fuzzy_byte) {
              this.treeNodeALLOpen(true)

              if (!this.has_supper_search && !this.show_computer && this.search_select_auto) {//如果是对话框,不显示主机
                this.$nextTick(() => {

                  let arr = data.data
                  if (arr && arr[0]
                    && arr[0]["children"] && arr[0]["children"][0]
                    && arr[0]["children"][0]["children"] && arr[0]["children"][0]["children"][0]) {
                    let checked = arr[0]["children"][0]["children"][0]
                    this.$refs.tree.setCurrentKey(checked["id"])
                    this.$emit("item_click", checked, this.search__tree_data.fuzzy_byte, 'target')

                    // if (!this.current_value && (!this.current_value_type || (this.current_value_type && this.current_value_type === item["id_type"])) ){
                    //   this.current_value = checked[this.value_field];
                    //   this.current_data = checked;
                    // }
                  }

                })
              } else if (!this.has_supper_search && this.show_computer && this.search_select_auto) {//显示主机
                this.$nextTick(() => {

                  let arr = data.data
                  if (arr && arr[0]
                    && arr[0]["children"] && arr[0]["children"][0]
                    && arr[0]["children"][0]["children"] && arr[0]["children"][0]["children"][0] && arr[0]["children"][0]["children"][0]["children"][0]) {
                    let checked = arr[0]["children"][0]["children"][0]["children"][0]
                    this.$refs.tree.setCurrentKey(checked["id"])
                    this.$emit("item_click", checked, this.search__tree_data.fuzzy_byte, 'target')
                    // if (!this.current_value && (!this.current_value_type || (this.current_value_type && this.current_value_type === item["id_type"])) ){
                    //   this.current_value = checked[this.value_field];
                    //   this.current_data = checked;
                    // }
                  }

                })
              }


            } else {
              this.treeNodeALLOpen(false)
            }
            this.data = data.data
            // if (this.default_env) {//默认选择节点
            //   // this.treeNodeALLOpen(true)
              // this.set_default_node()
            //
            // }
            this.$forceUpdate()
            this.tree_dict_data = {}
            this.get_tree_dict(data.data, this.tree_dict_data)    // tree_dict_data数据形式 => 项目children各个数据的id、children的children各个数据的id为key，字典类型的项目数据为value

            setTimeout(()=>{
              this.set_current_node(this.current_value);
            }, 500);

          } else {
            this.$message.error(data.msg);
          }

        } else {
          this.$message.error('系统错误');
        }
      },

      fix_icon(node) {
        if (node.is_watch) {

          node.iconSkin = this.server_unchecked_icon_collect
        } else {
          node.iconSkin = this.server_unchecked_icon
        }

      },

      async get_ztree_data() {
        this.loading = true
        const response = await API.GET('/omnis/fort_service/query_server_tree')
        this.loading = false
        let data = response.data
        if (data.success) {
          let org_data = data.data
          this.ztree_data_dict = {}
          this.has_watch = false
          org_data.map((item) => {
            if (item.pid === undefined) {
              if (item.env_code === '3') item.iconSkin = this.formal_env_icon
              else if (item.env_code === '4') item.iconSkin = this.dev_env_icon
              else item.iconSkin = this.other_env_icon
            } else {
              this.fix_icon(item)

            }

            this.ztree_data_dict[item.id] = item
          })

          if (this.has_watch_node(org_data)) {
            this.collect_show = true
          }


          this.ztree_data = org_data

          setTimeout(()=>{
            this.set_current_node(this.current_value);
          }, 500);

        }
      },

      // 根据server_id获取ip
        async get_server_ip(id, callback){
            var datas = {}
            datas.server_id = id
            const response = await API.GET("/omnis/assets_operations/new_assets/host_main", datas)
            if (response && response.data) {
              var data = response.data
              let server_dict = null
              if(data.success){
                if(data.data.main_information.server_ip){
                  let server_data = data.data.main_information
                  server_dict = {
                    id: server_data.server_id,
                    name: server_data.server_ip,
                    server_env_id: data.data.server_env_id,
                    id_type: "server"
                  }
                }
              }
              if (callback){
                callback(server_dict)
              }
              return server_dict

            }
        },
    },


  };
</script>
<style scoped>

  .env_icon {
    height: 1rem;
    width: 1rem;
    transform: translateY(2px);

  }

  .server-info {
    overflow: hidden;
  }

  table {
    border-color: #D4D4D4;
    border-style: dotted;
    border-width: 0px;
    border-right-width: 1px;
    border-bottom-width: 1px;
    margin: 0;
    padding: 0;
    border-spacing: 0;
    width: 100%
  }

  td {
    border-color: #D4D4D4;
    border-style: dotted;
    border-width: 0px;
    border-top-width: 1px;
    border-left-width: 1px;
    color: #333;
    padding: 5px;
    font-size: 14px;
  }

  tr > td:first-child {
    text-align: right;
    padding-right: 10px;
  }


  .search_type {
    text-align: right;
    padding-right: 10px
  }

  .el-button {
    padding: 5px 5px !important
  }

  .el-button img {
    width: 20px
  }

  .icon {
    font-size: 18px
  }

  .el-form-item {
    width: 95%
  }

  .el-form-item-padding {
    padding-right: 10px
  }

  .data_type {
    padding-right: 2px;
  }


  .el-tree {
    min-width: 100%;
    display: inline-block !important;
  }

  .left_content {
    width: 1000px;
    height: 1000px;
  }


  .panel-header {
    background-color: #F2F2F2;
    background: -webkit-linear-gradient(top, #ffffff 0, #F2F2F2 100%);
    background: -moz-linear-gradient(top, #ffffff 0, #F2F2F2 100%);
    background: -o-linear-gradient(top, #ffffff 0, #F2F2F2 100%);
    background: linear-gradient(to bottom, #ffffff 0, #F2F2F2 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff, endColorstr=#F2F2F2, GradientType=0);
  }

  .panel-header, .panel-body {
    border-color: #D4D4D4;
  }

  .panel-header {
    padding: 5px;
    position: relative;
  }

  .panel-header, .panel-body {
    border-width: 1px;
    border-style: solid;
  }

  .panel-title {
    font-size: 12px;
    font-weight: bold;
    color: #777;
    height: 20px;
    padding-left: 5px;
    line-height: 20px;
  }

  .height_change {
    transition: height 0.5s;
  }

  .height_change2 {
    transition: height 1s;
  }


  .rotate {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }

  .rotate-change {
    transition: transform 0.5s;
  }

  .span-ellipsis {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }

  .tree-box {
    border: 1px solid rgb(221, 221, 221);
    overflow: hidden;
    padding-top: 2px;
    padding-left: 2px;
    box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 6px 1px;
  }

  .tree_body {
    height: 100%;
    overflow: auto;
  }


</style>
<style lang="less" scoped="">


  .directory-tree-menu {
    position: absolute;
    top: 0;

    margin: 0;
    padding: 6px 0;
    text-align: left;
    border: 1px solid #BFBFBF;
    border-radius: 3px;
    background-color: #EEE;
    z-index: 1000;
    box-shadow: 0 0 10px #AAA;
    font-size: 12px;

    .icon {
      font-size: 8px;
      transform: translateY(2px);
    }


    li {
      padding: 2px 15px;
      list-style: none outside none;
      cursor: default;
      color: #666;
    }

    li:hover {
      color: #EEE;
      background-color: #666;
    }


  }


  #resize {
    width: 5px;
    cursor: w-resize;
    position: relative;
    z-index: 10000;
    color: #efefef;
  }

  #resize:hover {
    cursor: w-resize;
    background: #818181;
  }


</style>
<style>

  .ztree li span.button.icon-blue-leaf_ico_open, .ztree li span.button.icon-blue-leaf_ico_close, .ztree li span.button.icon-blue-leaf_ico_docu {
    background: url('css/server_tree/img/blue_leaf.png') no-repeat center center;
    vertical-align: top;
    background-size: 20px;
  }

  .ztree li span.button.icon-green-leaf_ico_open, .ztree li span.button.icon-green-leaf_ico_close, .ztree li span.button.icon-green-leaf_ico_docu {
    background: url('css/server_tree/img/green_leaf.png') no-repeat center center;
    vertical-align: top;
    background-size: 20px;
  }

  .ztree li span.button.icon-red-leaf_ico_open, .ztree li span.button.icon-red-leaf_ico_close, .ztree li span.button.icon-red-leaf_ico_docu {
    background: url('css/server_tree/img/red_leaf.png') no-repeat center center;
    vertical-align: top;
    background-size: 20px;
  }

  .ztree li span.button.icon-server-selected_ico_docu {
    background: url('css/server_tree/img/server_selected.png') no-repeat center center;
    vertical-align: top;
    background-size: 100% 100%;
  }

  .ztree li span.button.icon-server_ico_docu {
    background: url('css/server_tree/img/server.png') no-repeat center center;
    vertical-align: top;
    background-size: 90% 90%;
  }


  .ztree li span.button.icon-server-collect_ico_docu {
    background: url('css/server_tree/img/serve_collect.png') no-repeat center center;
    vertical-align: top;
    background-size: 70% 70%;
  }


  .ztree li span.button.icon-server-collect-selected_ico_docu {
    background: url('css/server_tree/img/serve_collect_selected.png') no-repeat center center;
    vertical-align: top;
    background-size: 70% 70%;
  }

</style>



// WEBPACK FOOTER //
// search_tree.vue?4075a8f2